import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=7108a75e&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=7108a75e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7108a75e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7108a75e')) {
      api.createRecord('7108a75e', component.options)
    } else {
      api.reload('7108a75e', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=7108a75e&scoped=true&", function () {
      api.rerender('7108a75e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-221WAjsK73v1i/JS/comp/Paginate.vue"
export default component.exports